import { push } from 'connected-react-router';
import auth from '../../utils/auth';
import { SET_CURRENT_USER } from './constants';

export const setCurrentUser = (user) => ({
  type: SET_CURRENT_USER,
  payload: user,
});

export default (values, dispatch, props) => {
  return new Promise((resolve, reject) => {
    auth.login({
      realm: process.env.REACT_APP_AUTH_CONNECTION,
      username: values.email,
      password: values.password,
    }, (err, res) => {
      if (err) {
        reject(err);
      }
      if (res) {
        resolve(res);
        dispatch(push('/auth/callback'));
      }
    });
  });
};
